module.exports = __webpack_public_path__ + "img/02_1_5_3.3421ff91.png";